// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ribbon{background:#f1f1f1;border-top:1px solid #f1f1f1;padding:10px;z-index:10000}.cont__close{position:absolute;top:-25px;background:#f1f1f1;border-radius:50%;padding:7px;right:5px}#video{-o-object-fit:cover;object-fit:cover;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;min-width:100%;min-height:100%;z-index:200}", ""]);
// Exports
module.exports = exports;
